import { Component, inject } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

import { MenuService, ScreenSizeService } from '../../../../services';
import { FormlyService } from '../../../../services/component-services/formly.service';

@Component({
  selector: 'app-formly-horizontal-wrapper',
  templateUrl: './horizontal-wrapper.component.html',
  styleUrl: './horizontal-wrapper.component.scss',
  imports: [FormlyModule],
})
export class FormlyHorizontalWrapperComponent extends FieldWrapper {
  protected readonly menuService = inject(MenuService);
  protected readonly screenSizeService = inject(ScreenSizeService);
  private readonly formlyService = inject(FormlyService);

  get isMobile() {
    return this.formlyService.isMobile;
  }

  get isTextArea(): boolean {
    return this.field.type === 'textarea';
  }

  /**
   * The label / control split, as Bootstrap column counts.
   *
   * `props.wideField` narrows the label so a long text field gets the room. Widening the
   * field's own column alone does NOT do that — the label takes a proportional share of
   * whatever the column is, so a wider column just gives a wider gap.
   */
  protected get labelColumns(): string {
    if (this.props.mobileSplit) {
      return '6';
    }
    if (this.isMobile) {
      return '3';
    }
    return this.props.wideField ? '2' : '5';
  }

  protected get fieldColumns(): string {
    if (this.props.mobileSplit) {
      return '6';
    }
    if (this.isMobile) {
      return '9';
    }
    return this.props.wideField ? '10' : '7';
  }
}
